<template>
    <div class="import-feedback-drawer-csv-bar-card__csv-card">
        <span class="import-feedback-drawer-csv-bar-card__title">
            File:
        </span>
        <pendo-divider
            direction="vertical"
            decorative
            width="32px" />
        <div class="import-feedback-drawer-csv-bar-card__file-name-wrapper">
            {{ fileName }}
        </div>
    </div>
</template>
<script>
import { PendoDivider } from '@pendo/components';

export default {
    name: 'ImportFeedbackDrawerCsvBarCard',
    components: {
        PendoDivider,
    },
    props: {
        fileName: {
            type: String,
            required: true,
        },
    },
};
</script>
<style lang="less" scoped>
@import '@/voc/styles/voc.style.less';

.import-feedback-drawer-csv-bar-card {
    &__title {
        font-weight: 600;
    }
    &__csv-card {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
        row-gap: 6px;
        line-height: 120%;
        background: var(--palette-gray-10);
        border-radius: 3px;
        border: 1px solid var(--palette-gray-40);
        margin-top: 16px;
        padding: 10px 32px;
    }
    &__file-name-wrapper {
        position: relative;
    }
}
</style>
